import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';

export const SHIPMENT_ROUTES: Routes = [
  {
    path: 'shipments',
    loadComponent: () => import('./shipment-list/shipment-list.component').then(m => m.ShipmentListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'shipments/loadgate/matches/:matchId/agreement',
    loadComponent: () => import('./loadgate-agreement/loadgate-agreement-acceptance.component').then(m => m.LoadGateAgreementAcceptanceComponent),
    canActivate: [authGuard]
  },
  {
    path: 'shipments/:id',
    loadComponent: () => import('./shipment-details/shipment-details.component').then(m => m.ShipmentDetailsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'shipments/:id/payment',
    loadComponent: () => import('./shipment-payment/shipment-payment.component').then(m => m.ShipmentPaymentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'shipments/:id/payment-callback',
    loadComponent: () => import('./shipment-payment-callback/shipment-payment-callback.component').then(m => m.ShipmentPaymentCallbackComponent),
    canActivate: [authGuard]
  }
];
